import { createFileRoute } from '@tanstack/react-router'
// import { encounterByIdQueryOptions } from '~/features/dashboard/pages/encounters/api/queries';
import { EncounterDetailsPage } from '~/features/dashboard/pages/encounters/pages/encounter';
// import { getApiProgram } from '~/lib/utils';

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$program/encounters/encounter/$id',
)({
  validateSearch: (search) => ({
    name: String(search.name ?? ""),
    patientId: String(search.patientId ?? ""),
  }),
  // loader: async ({ context, params }) => {
  //   // const encounterId = params.id;
  //   // const apiProgram = getApiProgram(params.program ?? "");
  //   // Note: name is accessed in component via useSearch hook
  //   // Prefetch all queries you need
  //   // await Promise.all([
  //   //   context.queryClient.ensureQueryData(encounterByIdQueryOptions(encounterId, apiProgram ?? "", "")),
  //   // ]);
  // },
  component: () => (
    <section 
      role="region"
      aria-label="Dashboard overview"
      className="min-h-screen w-full mx-auto">
      <EncounterDetailsPage />
    </section>
  ),
  errorComponent: ({ error }: { error: Error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
        <h1 className="text-2xl font-bold">Encounter Details Error</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
})
